import { Face } from '@mui/icons-material'
import { Chip, Grid2 } from '@mui/material'

import { useDeleteFellow } from '../../api/fellows'

export const Fellows = ({ fellows, onDeleted }) => {
  const { mutate: deleteFellow, isPending } = useDeleteFellow()

  function handleDelete(fellow) {
    if (isPending) return
    deleteFellow(fellow, { onSuccess: () => onDeleted(fellow) })
  }

  if (!fellows.length) return null

  return (
    <Grid2 size={12}>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {fellows.map((f) => {
          return (
            <div key={f.id} style={{ marginRight: 8, marginBottom: 8 }}>
              <Chip
                icon={<Face />}
                label={`${f.firstName} ${f.lastName}`}
                onDelete={() => handleDelete(f)}
              />
            </div>
          )
        })}
      </div>
    </Grid2>
  )
}
